export default __webpack_public_path__ + "static/media/secondary.7a563493676864a4622cb2b9d9667dca.svg";